<template>
  <v-container>
    <div style="background-color: rgb(230, 233, 242); padding-left: 20px; padding-right: 20px; padding-bottom: 15px;">
      <h2 style="font-size: 2.5rem; color: rgb(0, 30, 67)">Contacto</h2>
      ¿Tienes dudas o comentarios? Estamos aquí para ayudarte. Contacta al Equipo Ambiental de UNODC a través del siguiente correo <b>unodc-comms.envteam@un.org</b> y te responderemos a la brevedad.
      <br><br>
      <v-row>
            <v-col cols="12" lg="4">
              <v-img class="align-end text-white" contain width="320" :src="require('../assets/B1.jpeg')"></v-img> 
            </v-col>
            <v-col cols="12" lg="4">
              <v-img class="align-end text-white" contain width="320" :src="require('../assets/B2.jpg')"></v-img> 
            </v-col>
            <v-col cols="12" lg="4">
                <v-img class="align-end text-white" contain width="320" :src="require('../assets/B3.jpg')"></v-img> 
            </v-col>
        </v-row>
    </div>
  </v-container>
</template>
  
  <script>
    export default {
      name: 'HelloWorld',
  
      data: () => ({
        
      }),
    }
  </script>
  <style>
      p {
        font-family: 'Heebo', sans-serif !important;
          font-size: 17px;        
          line-height: 1.6em;
      }
      h1 {
        font-family: 'Heebo', sans-serif !important;
          font-size: 2.5rem;
      }
      h2 {
        font-family: 'Sofia Sans', sans-serif !important;
      }
      h3 {
        font-family: 'Sofia Sans', sans-serif !important;
      }
      h5 {
          font-family: 'Sofia Sans', sans-serif !important;
          font-size: 1.25rem;
      }
      
  </style>